<template>
  <ul class="border rounded mt-4">
    <li>
      <TableRowAction
        :message="newItemMessage"

        @open="focusOnInput"
        ref="row-action"
      >
        <slot name="edit-item-content">
          <div class="list-item d-flex justify-content-between new-item">
            <input
              v-model="newItemContent"
              :placeholder="inputPlaceholder"
              
              ref="input"
              class="p-2"

              @keydown="keydown"
            >
            <button v-if="newItemContent.length"
              class="btn btn-light flex-shrink-0"
              @click="addItem"
            >
              Voeg item toe
            </button>
            <span v-else></span>
          </div>
        </slot>
      </TableRowAction>
    </li>
    <GenericCrudItem v-for="(str, index) in list"
      class="list-item"
      :value="str"
    
      :key="str + index"
      @remove="deleteItemFromIndex(index)"
      @save="val => saveItem(val, index)"
    >
      {{ str }}
      
      <template #edit-item>
        <slot name="edit-item-content" :value="str"></slot>
      </template>
    </GenericCrudItem>
  </ul>
</template>

<script>

import GenericCrudItem from "./GenericCrudItem.vue"

import TableRowAction from "./../TableComposables/TableRowAction.vue"

export default {
  components: {
    GenericCrudItem,
    TableRowAction,
  },
  props: {
    newItemMessage: String,
    inputPlaceholder: String,

    value: Array,
  },
  data() {
    return {
      newItemContent: "",

      list: this.value,
    }
  },
  methods: {
    saveItem(value, index) {
      this.list.splice(index, 1, value)
    },
    keydown({key}) {
      if (key === "Enter") this.addItem()
    },
    deleteItemFromIndex(index) {
      this.list.splice(index, 1)
    },
    addItem() {
      this.list.unshift(this.newItemContent)
      this.newItemContent = ""

      this.focusOnInput()
    },
    focusOnInput() {
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus()
        }
      })
    },
  },
  watch: {
    list(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.list = val
    },
  },
}

</script>

<style scoped>

li {
  list-style: none;
}

input {
  flex-basis: 100%;
  flex-grow: 1;
}

li + li {
  border-top: 1px solid #dee2e6;
}


.list-item {
  position: relative;
  font-size: 14px !important;
  cursor: text;
  transition-duration: .15s;
}

.list-item:hover {
  background-color: rgb(248, 248, 248);
}

</style>
